import {
  UNBLOCK_CHANNEL_INIT,
  UNBLOCK_CHANNEL_SUCCESS,
  UNBLOCK_CHANNEL_ERROR,
} from '../../actions/channelBlocker/constants';

const initialState = {
  inProgress: false,
  success: false,
  error: null,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UNBLOCK_CHANNEL_INIT: {
      return { ...initialState, inProgress: true };
    }
    case UNBLOCK_CHANNEL_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case UNBLOCK_CHANNEL_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    default:
      return state;
  }
};
